<template>
    <div class="card-content" v-loading="loadParent || loading">
        <el-dialog
            title="Configurações do card"
            :visible.sync="modalCard"
            :close-on-click-modal="false"
            width="30%"
            class="card-modal">
            
            <el-form :model="model" :ref="`formCard-${id}`" size="mini" label-position="top">
                <el-form-item label="Título do KPI" prop="title">
                    <el-input size="small" v-model="model.title"></el-input>
                </el-form-item>
                <el-form-item label="Modelo de DRE" prop="modeloDre">
                    <el-select class="w-100" size="small" v-model="model.modeloDre" filterable clearable :placeholder="`Selecione o modelo de DRE`">
                        <el-option
                        v-for="item in listaModelo"
                        :key="item.id"
                        :label="item.label"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="model.nomeFator1" prop="fator1">
                    <i @click="editLabel = true" class="edit-label fas fa-pen"></i>
                    <el-input v-show="editLabel" class="edit-label-input" size="mini" v-model="model.nomeFator1" @blur="editLabel = false"></el-input>
                    <el-select class="w-100" size="small" v-model="model.fator1" filterable clearable :placeholder="`Selecione o fator 1`">
                        <el-option
                        v-for="item in optionsLinhasDRE"
                        :key="item.id"
                        :label="item.nome"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="model.nomeFator2" prop="fator2" class="position-relative">
                    <i @click="editLabel2 = true" class="edit-label fas fa-pen"></i>
                    <el-input v-show="editLabel2" class="edit-label-input" size="mini" v-model="model.nomeFator2" @blur="editLabel2 = false"></el-input>
                    <el-checkbox class="position-absolute c-m2" v-model="model.metroQuadrado">Metro quadrado</el-checkbox>
                    <el-select class="w-100" size="small" v-model="model.fator2" filterable clearable :disabled="model.metroQuadrado" :placeholder="`Selecione o fator 1`">
                        <el-option
                        v-for="item in optionsLinhasDRE"
                        :key="item.id"
                        :label="item.nome"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Configuração de ordenação">
                    <el-button-group title="Ordenar por">
                        <el-button @click.native="groupOrdenacao(0)" :type="model.ordenadorGrafico == 0 ? 'primary' : 'default'">Fator 1</el-button>
                        <el-button @click.native="groupOrdenacao(1)" :type="model.ordenadorGrafico == 1 ? 'primary' : 'default'">Fator 2</el-button>
                        <el-button @click.native="groupOrdenacao(2)" :type="model.ordenadorGrafico == 2 ? 'primary' : 'default'">Resultado</el-button>
                    </el-button-group>&nbsp;
                    <el-button @click="tipoOrdenacaoChange" title="tipo de ordenação" type="primary" :icon="tipoOrdenacao ? 'el-icon-top' : 'el-icon-bottom'">
                    {{ tipoOrdenacao ? 'Crescente' : 'Decrescente' }}
                    </el-button>
                </el-form-item>

                <div class="formula-content" v-show="model.fator1 && model.fator2 || model.fator1 && model.metroQuadrado">
                    <h5>Fórmula</h5>
                    <p>Fórmula gerada a partir dos fatores 1 e 2</p>
                    <div class="formula-body">
                        <div class="f-fator1" v-if="model.fator1">Fator 1</div>
                        <span class="f-operador">/</span>
                        <div class="f-fator2" v-if="model.fator2 || model.metroQuadrado">{{ model.metroQuadrado ? 'M²' : 'Fator 2' }}</div>
                        <template v-if="!model.metroQuadrado">
                            <span class="f-operador">x</span>
                            <div class="f-val">100%</div>
                        </template>
                    </div>
                </div>
                
            </el-form>
            <span slot="footer" class="dialog-footer">
                    <el-button size="small" @click="fecharModal">Fechar</el-button>
                    <el-button size="small" type="primary" @click="Salvar" v-loading="formloading" :disabled="formloading">Salvar</el-button> 
                </span>
        </el-dialog>

        <div v-if="loadParent || loading || hasError">
            <img class="img-fluid chart-img" :src="require(`@/assets/KPI.svg`)" alt="Home card não carregado" style="display:block; margin:0 auto; width:100px;"/>
        </div>
        <div v-else>
            <div class="dcard-header">
                <h4 :style="`color: ${color}`">{{ cardInfo.title }}</h4>
                <i v-show="filtros.tipo === ''" class="fas fa-ellipsis-h dcard-config" @click="editCard" v-if="temAcesso('Kpi','Salvar')"></i>
            </div>
            <div class="dcard-body">
                <p>{{ cardInfo.metroQuadrado ? 'R$/m²' : '' }} {{ cardInfo.value }} {{ !cardInfo.metroQuadrado ? '%' : '' }}</p>
            </div>
            <div class="dcard-footer">
                <el-tag v-for="tag in cardInfo.tags" :key="tag" :style="`background-color: ${color}`" size="mini" effect="dark">{{ tag }}</el-tag>

                <div class="pull-right dcard-chart">
                    <svg width="55" height="20" viewBox="0 0 77 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="12" y="14" width="4" height="15" :fill="color"/>
                        <rect x="6" y="16" width="4" height="13" :fill="color"/>
                        <rect y="12" width="4" height="17" :fill="color"/>
                        <rect x="54" y="12" width="4" height="17" :fill="color"/>
                        <rect x="60" y="8" width="4" height="21" :fill="color"/>
                        <rect x="66" y="5" width="4" height="24" :fill="color"/>
                        <rect x="73" y="3" width="4" height="26" :fill="color"/>
                        <rect x="18" y="3" width="4" height="26" :fill="color"/>
                        <rect x="24" width="4" height="29" :fill="color"/>
                        <rect x="30" y="7" width="4" height="22" :fill="color"/>
                        <rect x="36" y="3" width="4" height="26" :fill="color"/>
                        <rect x="42" y="5" width="4" height="24" :fill="color"/>
                        <rect x="48" width="4" height="29" :fill="color"/>
                    </svg>

                </div>
            </div>
        </div>
    </div>
</template>
 
 <script>
 export default {
    name: 'dashboard-card',
    props: {
        id: String,
        datas: Object,
        color: {
            type: String,
            default: '#10B2EF'
        },
        listaModelo: Array,
        loadParent: Boolean
    },
    data() {
        return {
            modalCard: false,
            editLabel: false,
            editLabel2: false,
            loading: false,
            hasError: false,
            formloading: false,
            tipoOrdenacao: false,
            cardInfo: {
                title: 'Título KPI',
                value: 0,
                tags: [],
                metroQuadrado: false,
                fator1: '',
                fator2: '',
                nomeFator1: 'Fator 1',
                nomeFator2: 'Fator 2',
                ordenadorGrafico: '',
                tipoOrdenacao: false
            },
            model: {
                id: '',
                title: '',
                value: '',
                tags: [],
                fator1: '',
                nomeFator1: 'Fator 1',
                nomeFator2: 'Fator 2',
                modeloDre: '',
                fator2: '',
                metroQuadrado: false,
                ordenadorGrafico: '',
                tipoOrdenacao: false
            },
            paramsFiltros: {},
            optionsLinhasDRE: []
        }
    },
    methods: {
        editCard() {
            this.modalCard = true;
            
            this.model = Object.assign(this.datas, this.cardInfo);
        },
        fecharModal() {
            this.modalCard = false;
        },
        async Salvar() {
            this.formloading = true;
            let response = await this.axios.post(this.$urls.KPIS,this.model);

            this.formloading = false;

            if(response.status !== 200) {
                return;
            }
            this.formatValuesFilter(this.filtros);
            this.modalCard = false;
        },
        async getListaDre(modeloId) {
            let response = await this.axios.get(`${this.$urls.LINHAS_DRE}?modeloDre=${modeloId}`);

            if(!response.data.length) {
                return;
            }

            this.optionsLinhasDRE = response.data.map(item => ({
                ...item,
                id: item.id || item._id,
                nome: item.nome || item.label || item.text || item.descricao
            }));
        },
        async getCardData() {
            this.loading = true;
            this.hasError = false;
            
            let response = await this.axios.get(`${this.$urls.KPIS}/${this.id}`, {
                params: this.paramsFiltros
            });

            this.loading = false;

            if(response.status !== 200) {
                this.hasError = true;
                return;
            }

            this.cardInfo = response.data;
            this.cardInfo.tags = [!response.data.metroQuadrado ? 'Linha DRE' : 'M²'];
            this.tipoOrdenacao = response.data.tipoOrdenacao || false;
        },
        formatValuesFilter(filtros) {
            this.paramsFiltros = {};

            const formatarDataInicial = (data) => this.moment(data).startOf('month').format('YYYY-MM-DD');
            const formatarDataFinal = (data) => this.moment(data).endOf('month').format('YYYY-MM-DD');

            if(filtros.datas &&  filtros.datas.length) {
                this.paramsFiltros.DataInicial = formatarDataInicial(filtros.datas[0]);
                this.paramsFiltros.DataFinal = formatarDataFinal(filtros.datas[1]);
            }
            if(filtros.tipo) {
                this.paramsFiltros[filtros.selectedGroup ? 'Cluster._id' : 'Grupo._id'] = filtros.tipo;
            }
            if(filtros.grupo) {
                this.paramsFiltros['Loja._id'] = filtros.grupo;
            }
            if(filtros.comparativo) {
                this.paramsFiltros['comparativo'] = filtros.comparativo;
            }
        },
        groupOrdenacao(num){
            let defaultValue = this.model.ordenadorGrafico.toString();
            this.model.ordenadorGrafico = defaultValue === num ? 0 : num;
        },
        tipoOrdenacaoChange() {
            this.tipoOrdenacao = !this.tipoOrdenacao;
            this.model.tipoOrdenacao = this.tipoOrdenacao;
        }
    },
    computed: {
		filtros: {
            get() {
                return this.$store.state.filtros;
            },
            set(value) {
                this.$store.commit('updateFiltros', value);
            }
        }
	},
    watch: {
        'model.metroQuadrado'() {
            this.model.fator2 = ''
        },
        'model.modeloDre'(modelo) {
            if(!modelo){
                return;
            }
            this.getListaDre(modelo);
        },
        datas: {
            deep: true,
            handler(dt) {
                if(!Object.keys(dt || {}).length){
                    return;
                }

                this.cardInfo = Object.assign(this.cardInfo, dt);
                this.cardInfo.tags = [!dt.metroQuadrado ? 'Linha DRE' : 'M²'];
            }
        }
    }
 }
 </script>
 
 <style lang="scss">
    .card-content {
        padding: 15px;
        .el-tag {
            width: auto;
            margin-right: 6px;
            border: 0;
            font-size: 10px;
        }
        position:relative;
        .dcard-header {
            h4 {
                font-size:12px;
                font-weight: 800;
            }
        }
        .dcard-body {
            p {
                font-size: 19px;
                margin: 13px 0;
                font-weight: bold;
            }
        }
        .dcard-config {
            position: absolute;
            top: 10px;
            right: 10px;
            color: #939393;
            cursor:pointer;
            transition:0.3s;
            border-radius: 9px;
            padding: 4px 6px  4px 5px;
            &:hover {
                background: #ddd;
            }
        }
        .dcard-chart {
            margin:0;
            position: absolute;
            bottom: 13px;
            right: 15px;
        }
        .formula-body {
            margin-bottom: 10px;
            .f-fator1, 
            .f-fator2, 
            .f-val {
                color: #fff;
                padding: 3px 6px;
                font-size: 12px;
                margin-right: 8px;
                border-radius: 5px;
                display:inline-block;
            }

            .f-fator1 {
                background: #7495f1;
            }
            .f-fator2 {
                background: #7495f1;
            }
            .f-val {
                background: #bf74f1;
            }
            .f-operador {
                margin: 0 4px 0 -4px;
                font-weight: bold;
                font-size: 14px;
                color: #df2727;
            }
        }
        i.edit-label {
            position: absolute;
            top: -17px;
            left: 0;
            cursor: pointer;
        }
        .edit-label-input {
            position: absolute;
            top: -28px;
            width: 95.4%;
            margin-left: 4.5%;
        }
        label[for=fator1].el-form-item__label, label[for=fator2].el-form-item__label {
            margin-left: 20px !important; 
        }
        min-height:123px !important;
    }
    .card-modal {
        label.el-form-item__label {
            margin: 0 0 -12px;
        }
        .c-m2 {
            right:0;
            top:-28px;
        }
    }
 </style>
